import { baseUrl, API } from "./general.actions";
//import { type } from "os";
//import Base from "../../components/Layout/Base";
//import { Tab } from "@material-ui/core";
//import { table } from "console";
export const apiGetPDF = (ActionType, url, toDownload) => ({
    type: ActionType,
    payload: {
        url: baseUrl + url + toDownload,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGetPDF_withTarget = (ActionType, url, mpID, lang, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + url + mpID + "/" + lang,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
// GetAll : baseUrl + tableName (url)
// e.g.: localhost:3000/api/TabPlants
export const apiGet = (ActionType, url) => ({
    type: ActionType,
    payload: {
        url: baseUrl + url,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
// GetAll : baseUrl + tableName (url)
// e.g.: localhost:3000/api/TabPlants
export const apiGetByUserID = (ActionType, url, userID) => ({
    type: ActionType,
    payload: {
        url: baseUrl + url + "User/" + userID,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGetByUserID_withTarget = (ActionType, url, userID, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + url + "User/" + userID,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGet_withTarget = (ActionType, url, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + url,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGetHowToByLang = (ActionType, tableName, lang) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'lang/' + lang,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
// GetByID: baseUrl + TableName (from) + Id + Name 
// e.g.: localhost:3000/api/TabPlants/rfdwed/Plants
export const apiGetByID = (ActionType, tableName, Id, name) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + Id + "/" + name,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGetByID_And_UserID = (ActionType, tableName, Id, name, userID) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + Id + "/" + name + "/" + userID,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGet_Reports_ByID_And_UserID = (ActionType, tableName, Id, type, userID, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + Id + "/Reports/" + type + "/" + userID,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGet_ReportSets_By_ReportGUID_withTargetName = (ActionType, tableName, reportGUID, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "/ReportSets/" + reportGUID,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGet_ReportSets_Datapoint_By_ReportSet_GUID_withTargetName = (ActionType, tableName, reportSetGUID, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "/ReportSetDataPoints/" + reportSetGUID,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGet_ReportDataPoints_ByReportGUID = (ActionType, tableName, RepGUID, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "/Report/" + RepGUID,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const api_GetListofFiles_withTarget = (ActionType, tableName, objID, userID, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "Files/" + objID + "/" + userID,
        targetName: TargetName,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
//api/TabSystemUsers/SystemUsers/{userID}
export const apiGetAllUsers_By_UserID = (ActionType, tableName, userID) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "SystemUsers/" + userID,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
//api/TabSystemUsers/{callerUserID}/{firmaId}/SystemUsers
export const apiGetAllUsers_By_UserID_And_FirmaID = (ActionType, tableName, userID, firmaID) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + userID + "/" + firmaID + "/SystemUsers",
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
//SystemUsersCount
export const apiGetAllUsersCount_By_UserID_And_FirmaID_WithTarget = (ActionType, tableName, userID, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + userID + "/SystemUsersCount",
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
//SystemUserCompanyCount
export const apiGetAllFirmasCount_ForUsers_Dic_WithTarget = (ActionType, tableName, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "SystemUserCompanyCount",
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
//export const user_getEmailList_withTarget = (userGroup, listOfFirmaGUID, TargetName) => {
export const apiGet_EmailList_withTarget = (ActionType, tableName, userGroup, includeSuperAdmin, includeConsultants, listOfFirmaGUID, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + userGroup + "/" + includeSuperAdmin + "/" + includeConsultants,
        method: 'get',
        listOfComs: listOfFirmaGUID,
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiSendEmail = (ActionType, url, title, emailBody, to, cc) => ({
    type: ActionType,
    payload: {
        url: baseUrl + url + 'Send',
        method: 'post',
        title,
        emailBody,
        to,
        cc,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGetByID_withTarget = (ActionType, tableName, Id, name, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + Id + "/" + name,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGetBySpecifiedID_withTarget = (ActionType, tableName, Id, IdType, name, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + IdType + Id + "/" + name,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
// e.g.: api/TabMaintenancePlans (post call)
export const apiAddNew = (ActionType, tableName, newObject) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName,
        data: newObject,
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiAddNew_Files = (ActionType, tableName, newObject, ManyMany_tableName, devID) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + ManyMany_tableName + devID,
        data: newObject,
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiDelete_Files = (ActionType, tableName, fileServerID, ManyMany_tableName, devID) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + ManyMany_tableName + devID + "/" + fileServerID,
        method: 'delete',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
// (ActionType, tableName, newObjectList, relatedID, relationField)
export const apiAddNewList = (ActionType, tableName, newObjectList, relatedID, relationField) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName,
        data: { listToAdd: newObjectList, relatedID, relationField },
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
//
//relatedID: for example in MPTask: relatedMP_ID
//relationField: for example in MPTask: GUID (from maintenanceplanTask)
export const apiDeleteList = (ActionType, tableName, relatedID) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + relatedID,
        method: 'delete',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
// according to table names : 1 for first name and 2 for the second manymany relation name
export const apiAddNewList_manyMany = (ActionType, tableName, newObjectList, relationField1_InObjectList, relationField1_InManyManyTable, related2ID, relationField2_InManyManyTable) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName,
        data: { listToAdd: newObjectList, relationField1_InObjectList, relationField1_InManyManyTable, related2ID, relationField2_InManyManyTable },
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
// e.g.: api/TabDataPoints/Devices/vrt34v/DataPoints
//   or: api/TabDataPoints/PlantParts/r4r/DataPoints
export const apiGetBySpecifiedID = (ActionType, tableName, Id, IdType, name) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + IdType + Id + "/" + name,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiDeleteByID = (ActionType, tableName, Id) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + Id,
        method: 'delete',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
        guid: Id
    }
});
export const apiUserGroupLinkDelete = (ActionType, tableName, userGroupID, otherID) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + userGroupID + "/" + otherID,
        method: 'delete',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
        guid: otherID
    }
});
export const apiEdit = (ActionType, tableName, guid, edited) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + guid,
        method: 'put',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
        data: edited
    }
});
//api/TabPlants/BGANamesAndIDs
export const apiGetBGANamesAndIDs = (ActionType, tableName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "BGANamesAndIDs",
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
//api/TabDataPoints/{bgaName}/RTIPNummer
export const apiGetRelatedRTIPDataPoints = (ActionType, tableName, bgaName, dp_type) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + bgaName + "/RTIPNummer/" + dp_type,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
//api/TabFirmas/{firmaID}/MPStatistics
export const apiGetFirmaMPStatistics = (ActionType, tableName, firmaID) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + firmaID + "/MPStatistics",
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGetByGUID = (ActionType, tableName, guid) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + guid,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGetAllTags = (ActionType, tableName, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'Tags',
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGetFieldByGUID_withTargetName = (ActionType, tableName, guid, fieldName, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + guid + "/" + fieldName,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
//[HttpGet("GetChildrenSummaries/{ObjectType}/{ObjectGuid}/{comTypeGUID}")]
export const api_GetSammariesOfChildren = (ActionType, tableName, fatherType, fatherGUID, comTypeID, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'GetChildrenSummaries' + '/' + fatherType + '/' + fatherGUID + '/' + comTypeID,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGetByGUID_withTargetName = (ActionType, tableName, guid, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + guid,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiGetFiles_ByFirmaGUID_withTargetName = (ActionType, tableName, guid, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'AllComFile/' + guid,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
//currentOperatingHours/{bgaName}/{dataPointNumber}
export const apiGetDataPointOperatingHours = (ActionType, tableName, plantBGAName, dataPointRTIPNumber, usedFunc, startingDate, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'currentOperatingHours/' + plantBGAName + '/' + dataPointRTIPNumber + '/' + usedFunc + '/' + startingDate,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
//apiGetDataPointsToDisplay(DATAPOINT.ACTION_TYPES.GET_DATAPOINTS_TO_DISPLAY,DATAPOINT.TAB_NAME,plantBGAName,pointsList,TargetName)
export const apiGetDataPointsToDisplay = (ActionType, tableName, plantBGAName, pointsList, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'datapointsToDisplay/' + plantBGAName,
        data: pointsList,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiUser_SuperAdmin = (ActionType, tableName, userID, isSuper) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'Super/' + userID + '/' + isSuper,
        method: 'put',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiUser_SystemAdmin = (ActionType, tableName, userID, firmaID) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'SystemAdmin/' + userID + '/' + firmaID,
        method: 'put',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const apiUser_Consultant = (ActionType, tableName, userID, isConsultant) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'Consultant/' + userID + '/' + isConsultant,
        method: 'put',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED
    }
});
export const api_passRecover = (ActionType, tableName, email) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'Recover/' + email,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_toggleBoolean = (ActionType, tableName, functionText, guid) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + functionText + '/' + guid,
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
//DataPoints/{bgaName}/{rtipNummer}/{func}/{begin}/{end}/DailyValues
export const api_DailyValues_BetweenTwoDates = (ActionType, tableName, bgaName, rtipNummer, func, begin, end, dpType, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'DataPoints/' + bgaName + '/' + rtipNummer + '/' + func + '/' + begin + '/' + end + '/' + dpType + '/DailyValues',
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
        targetName: TargetName,
    }
});
//DataPointsReport/{begin}/{end}
export const api_DailyValues_ForListofDP_BetweenTwoDates = (ActionType, tableName, dpIDs, begin, end, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'DataPointsDailyReport/' + begin + "/" + end,
        dpIDs: dpIDs,
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
        targetName: TargetName,
    }
});
//
export const api_TrendValues_ForListofDP_BetweenTwoDates = (ActionType, tableName, dpIDs, begin, end, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'DataPointsTrendReport/' + begin + "/" + end,
        dpIDs: dpIDs,
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
        targetName: TargetName,
    }
});
export const api_getTargetActualSummary_values = (ActionType, tableName, bgaName, summaryGUID, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'TargetActualSummaryValues/' + bgaName + '/' + summaryGUID,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
        targetName: TargetName,
    }
});
export const api_getIfCannBeBHKW = (ActionType, tableName, type, guid, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'CannBeBHKW/' + type + '/' + guid,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
        targetName: TargetName,
    }
});
export const api_GetDetailsToDisplay = (ActionType, tableName, guid, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + 'DetailsToDisplay/' + guid,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
        targetName: TargetName,
    }
});
export const api_PhysicalSaveFileToServer = (ActionType, tableName, ManyToMany_tableName, fileServerObj, file) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "PhysicalSave/" + ManyToMany_tableName,
        //data: {
        //    file: file, dbObj: fileServerObj
        //} ,
        data: file,
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_PhysicalRemoveFileFromServer = (ActionType, tableName, ManyToMany_tableName, fileServerID) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "PhysicalRemove/" + ManyToMany_tableName + fileServerID,
        method: 'delete',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_PhysicalDownload_FromServer = (ActionType, tableName, ManyToMany_tableName, fileServerID, fileName, fileType, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "Download/" + ManyToMany_tableName + fileServerID + "/" + fileName + "/" + fileType,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
//ManyToMany_tabName, Guid, TargetName
export const api_getFilesList_ByGUID_withTarget = (ActionType, tableName, ManyToMany_tabName, Guid, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + ManyToMany_tabName + Guid,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_getIfAutoGenerated_withTarget = (ActionType, tableName, reportGuid, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "IsAutoGen/" + reportGuid,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_getFilesTree_ByPlantGUID_withTarget = (ActionType, tableName, PlantID, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "Plant/" + PlantID,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_addNewPlant2RTIP = (ActionType, tableName, bgaName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "NewRTIPPlant/" + bgaName,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_addNew_PW_NOT_HR_2_RTIP = (ActionType, tableName, obj) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "NewRTIP_PW_NOT_HR",
        data: obj,
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_addNew_Tab_BW_2_RTIP = (ActionType, tableName, obj) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "NewRTIP_Tab_BW",
        data: obj,
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_addNew_PW_HR_2_RTIP = (ActionType, tableName, obj) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "NewRTIP_PWHR",
        data: obj,
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_addNew_KeyVal2_and_PWReal = (ActionType, tableName, obj) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "KV_REAL_Insertion",
        data: obj,
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_addNew_BW_KeyVal2 = (ActionType, tableName, obj) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "KV_BW_Insertion",
        data: obj,
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_addNew_PW_2_RTIP_PW_ALLE = (ActionType, tableName, obj) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "PW_2_RTIP_PW_ALLE",
        data: obj,
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
//
export const api_addNew_BS_2_RTIP_BW_ALLE = (ActionType, tableName, obj) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "BS_2_RTIP_BW_ALLE",
        data: obj,
        method: 'post',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_deletePlant2RTIP = (ActionType, tableName, bgaName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "DeleteRTIPPlant/" + bgaName,
        method: 'get',
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_getDifference_ProzessWert_PWALLE_WithTarget = (ActionType, tableName, bgaName, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "DiffProzessWertPWALLE/" + bgaName,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_getDifference_Betriebsstunden_BSALLE_WithTarget = (ActionType, tableName, bgaName, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "DiffBetriebsstundenBSALLE/" + bgaName,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_fetch_AllPW_ALLE_from_RTIP = (ActionType, tableName, bgaName, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "AllPWALLE/" + bgaName,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_fetch_AllBS_ALLE_from_RTIP = (ActionType, tableName, bgaName, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "AllBSALLE/" + bgaName,
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_fetch_All_RTIP_Tab_BW = (ActionType, tableName, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "Tab_BW",
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_fetch_All_RTIP_PW_HR = (ActionType, tableName, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "PW_HR",
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_fetch_All_RTIP_PW_NOT_HR = (ActionType, tableName, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "PW_NOT_HR",
        method: 'get',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
export const api_fetchNamesDic = (ActionType, tableName, listOfGUID, TargetName) => ({
    type: ActionType,
    payload: {
        url: baseUrl + tableName + "NamesDic",
        data: listOfGUID,
        method: 'post',
        targetName: TargetName,
        onSuccess: ActionType + API.SUCCESSED,
        onError: ActionType + API.FAILED,
    }
});
//# sourceMappingURL=api.actions.js.map